import { render, staticRenderFns } from "./SetsFieldtype.vue?vue&type=template&id=5c08b782&"
import script from "./SetsFieldtype.vue?vue&type=script&lang=js&"
export * from "./SetsFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports